import React, { useState, useEffect, useContext } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faCog, faDownload } from '@fortawesome/free-solid-svg-icons';

import { useNavigate } from 'react-router-dom'

import { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion';
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { MyContext } from '../MainContext';
import { backendUrl } from '../utils/variables';

const DEFAULT_VERSION = 'v1.0.55';

export default function SettingsModal({ close }) {

    const navigate = useNavigate();
    const { user } = useContext(MyContext);
    const [appVersion, setAppVersion] = useState(DEFAULT_VERSION);
    const [emailNotifications, setEmailNotifications] = useState(true);
    const [savingEmailPref, setSavingEmailPref] = useState(false);

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL || ''}/firebase-messaging-sw.js`)
            .then((res) => res.text())
            .then((text) => {
                const match = text.match(/CACHE_VERSION\s*=\s*['"]([^'"]+)['"]/);
                if (match && match[1]) setAppVersion(match[1]);
            })
            .catch(() => {});
    }, []);

    useEffect(() => {
        if (!user?.user_id) return;
        fetch(`${backendUrl}/get_notification_preference.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id: user.user_id }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data && data.enabled === false) setEmailNotifications(false);
            })
            .catch(() => {});
    }, [user?.user_id]);

    const handleEmailNotificationToggle = async (checked) => {
        if (!user?.user_id) return;
        const previous = emailNotifications;
        setEmailNotifications(checked);
        setSavingEmailPref(true);
        try {
            const res = await fetch(`${backendUrl}/save_notification_preference.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    user_id: user.user_id,
                    email: user.email || '',
                    notification_type: 'email',
                    enabled: checked,
                }),
            });
            const data = await res.json();
            if (!data || data.success === false) {
                setEmailNotifications(previous);
            }
        } catch (e) {
            setEmailNotifications(previous);
        } finally {
            setSavingEmailPref(false);
        }
    };


    const go_to_edit = () => {

        navigate("/")
    }

    const go_to_about = () => {

      navigate("/about")
      close()
  }



  return (
    <div
    className={`modal  show`}
    tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
  >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title">Settings</h6>
          
            <FontAwesomeIcon className="ms-auto" icon={faClose} onClick={close} />
          </div>

       
          <div className="modal-body mb-2" style={{minHeight:'50vh'}}>


            {user?.user_id ? (
              <div className="form-check form-switch mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="emailNotificationsToggle"
                  checked={emailNotifications}
                  disabled={savingEmailPref}
                  onChange={(e) => handleEmailNotificationToggle(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="emailNotificationsToggle">
                  Email notifications
                </label>
                <div className="text-muted" style={{ fontSize: 'smaller' }}>
                  {emailNotifications
                    ? 'You will receive Clowza emails about prayers, goals, messages, and insights.'
                    : 'You will not receive Clowza notification emails. Password reset emails still send.'}
                </div>
              </div>
            ) : null}


           {3 < 2 &&  <button onClick={go_to_edit} className='btn btn-outline btn-outline-dark'>
                    <FontAwesomeIcon icon={faCog} />
                    
                    <span style={{marginLeft:12}}>Edit Profile</span>
            </button> }

            {<button onClick={go_to_about} className='btn text-dark mt-2'>
                    <FontAwesomeIcon icon={faInfoCircle} />
                    
                    <span style={{marginLeft:12}}>About Clowza</span>
            </button> }


            <div className="results-help text-left my-4 refs-div" style={{fontSize:'smaller'}}>
                
                    <h6><b>How to install App</b></h6>
                    <hr/>
                    <p><b>Android:</b> Get Clowza on Google Play:</p>
                    <button onClick={() => { navigate('/mobile_app'); close(); }} className="btn btn-primary btn-sm">
                        <FontAwesomeIcon icon={faDownload} className="me-1" />
                        Download Android App
                    </button>
                    

                    <p className="mt-3 mb-2"><b>iPhone:</b> Use the share button then &quot;Add to Homescreen&quot;.</p>
                    
                    <p className="mt-3 mb-0">Need assistance or have feedback? Email <a href="mailto:support@clowza.com"><b>support@clowza.com</b></a> or <a href="mailto:clowzamail@gmail.com"><b>clowzamail@gmail.com</b></a></p>
                </div>

         <p className='text-center' style={{fontSize:'smaller'}}>Clowza {appVersion}</p>

          </div>
        </div> 
      </div>
    </div>
  );
}
